import { IDemoSignUpParams } from '@aqx-core/common/api/user-account';

export enum ESignUpDemoContent {
  FORM = 'FORM',
  COMPLETE = 'COMPLETE'
}

export interface IOpenDemoAccountParams {
  params: IDemoSignUpParams;
  onError: (message: string) => void;
  onSuccess?: () => void;
  withAuth?: boolean;
}
